import { CalendarDay, numberToCurrencyString } from 'further-ui/utils';
import Table, { Column as TableColumn } from 'further-ui/components/Table';
import { CurrencyCode } from 'further-types/lp/vehicle';
import AvatarWithName from 'components/new/AvatarWithName';

const EqualisationInterestCalculationsItem: React.FC<{
  action: {
    id: string;
    name: string;
    ledgerDate: CalendarDay;
    totalPayableValueLcy: number;
    newInvestorBreakdown: Array<{
      investorName: string;
      commitmentId: string;
      investments: number;
      fees: number;
      expenses: number;
      workingCapital: number;
      returnOfCapital: number;
      netCallOrDistribution: number;
      payableValue: number;
      capitalContribution: number;
      cumulativePayableValue: number;
      equalisationInterestTotalLcy: number;
      equalisationInterestPercentage: number;
    }>;
  };
  baseCurrency: CurrencyCode;
  index: number;
  isLastElement: boolean;
}> = ({ action, baseCurrency }) => {
  const rows = action.newInvestorBreakdown.map((item) => ({
    ...item,
    id: item.commitmentId,
  }));

  const columns: Array<TableColumn<(typeof rows)[number]>> = [
    {
      key: 'investorName',
      label: 'Name',
      render: ({ investorName }) => <AvatarWithName name={investorName} />,
      width: 250,
    },
    {
      key: 'investments',
      label: 'Call - Investments',
      width: 160,
      render: (row) =>
        numberToCurrencyString(row.investments, {
          fallback: '-',
          currency: baseCurrency,
          negativeInBrackets: true,
        }),
    },
    {
      key: 'expenses',
      label: 'Call - Expenses',
      width: 160,
      render: (row) =>
        numberToCurrencyString(row.expenses, {
          fallback: '-',
          currency: baseCurrency,
          negativeInBrackets: true,
        }),
    },
    {
      key: 'returnOfCapital',
      label: 'Capital refunds',
      width: 160,
      render: (row) =>
        numberToCurrencyString(row.returnOfCapital, {
          fallback: '-',
          currency: baseCurrency,
          negativeInBrackets: true,
        }),
    },
    {
      key: 'workingCapital',
      label: 'Call - general capital',
      width: 160,
      render: (row) =>
        numberToCurrencyString(row.workingCapital, {
          fallback: '-',
          currency: baseCurrency,
          negativeInBrackets: true,
        }),
    },
    {
      key: 'netCallOrDistribution',
      label: 'Net call/(distribution)',
      width: 180,
      render: (row) =>
        numberToCurrencyString(row.netCallOrDistribution, {
          fallback: '-',
          currency: baseCurrency,
          negativeInBrackets: true,
        }),
    },
    {
      key: 'capitalContribution',
      label: 'Of which capital contribution',
      width: 200,
      render: (row) =>
        numberToCurrencyString(row.capitalContribution, {
          fallback: '-',
          currency: baseCurrency,
          negativeInBrackets: true,
        }),
    },

    {
      key: 'payableValue',
      label: 'Net minus capital contribution',
      width: 200,
      render: (row) =>
        numberToCurrencyString(row.payableValue, {
          fallback: '-',
          currency: baseCurrency,
          negativeInBrackets: true,
        }),
    },
    {
      key: 'equalisationInterestTotalLcy',
      label: 'Equalisation interest payable / (receivable)',
      width: 300,
      render: (row) =>
        numberToCurrencyString(row.equalisationInterestTotalLcy, {
          fallback: '-',
          currency: baseCurrency,
          negativeInBrackets: true,
        }),
    },
  ];
  return (
    <Table
      scrollable
      showHeaderBorder
      showTopBorder
      columns={columns}
      rows={rows}
    />
  );
};

export default EqualisationInterestCalculationsItem;
